"use client";

import * as React from "react";
import { cn } from "@/lib/utils";
import { Z_INDEX } from "./z-index";

export interface XPNotificationProps {
  expGained: number;
  show: boolean;
  onComplete?: () => void;
  position?: "fixed" | "absolute";
  className?: string;
}

export function XPNotification({
  expGained,
  show,
  onComplete,
  position = "fixed",
  className,
}: XPNotificationProps) {
  const [isVisible, setIsVisible] = React.useState(false);
  const [isAnimating, setIsAnimating] = React.useState(false);

  React.useEffect(() => {
    if (show) {
      setIsVisible(true);
      setIsAnimating(true);

      const timer = setTimeout(() => {
        setIsAnimating(false);
        setTimeout(() => {
          setIsVisible(false);
          onComplete?.();
        }, 300);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [show, onComplete]);

  if (!isVisible) return null;

  return (
    <div
      className={cn(
        "pointer-events-none flex items-center justify-center",
        position === "fixed" ? "fixed inset-0" : "absolute inset-0",
        className
      )}
      style={{ zIndex: Z_INDEX.TOAST }}
    >
      <div
        className={cn(
          "flex items-center gap-2 rounded-full px-5 py-2.5",
          "bg-gradient-to-r from-amber-400 via-orange-500 to-rose-500",
          "text-white shadow-[0_10px_32px_-6px_rgba(251,146,60,0.6)]",
          "transition-all duration-500 ease-out",
          isAnimating
            ? "translate-y-0 scale-100 opacity-100"
            : "translate-y-4 scale-90 opacity-0"
        )}
      >
        <span className="text-lg">⚡</span>
        <span className="text-sm font-bold">+{expGained} XP</span>
        <span className="text-lg">✨</span>
      </div>
    </div>
  );
}
